import React, { useEffect, useContext, useReducer } from 'react';
import reducer from '../reducers/filter_reducer';
import {
  LOAD_PRODUCTS,
  SET_GRIDVIEW,
  SET_LISTVIEW,
  UPDATE_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
} from '../actions';
import { useProductsContext } from './products_context';

const initialState = {
  filtered_products: [],
  all_products: [],
  grid_view: true,
  sort: {
    createdAt:"asc",
    weight:"asc"
  },
  filters: {
    text: '',
    metalType: 'all',
    category: 'all',
    name: 'all',
    min_price: 0,
    max_price: 0,
    price: 0,
    shipping: false,
    sleeves: 'all',
    collar: 'all',
    offers: "all"
  },
};

const FilterContext = React.createContext();

export const FilterProvider = ({ children }) => {
  const { products } = useProductsContext();
  const [state, dispatch] = useReducer(reducer, initialState);

  const setGridView = () => {
    dispatch({ type: SET_GRIDVIEW });
  };

  const setListView = () => {
    dispatch({ type: SET_LISTVIEW });
  };

  const updateSort = (value) => {
    // const value = e.target.value;
    dispatch({ type: UPDATE_SORT, payload: value });
  };

  const updateFilters = (e) => {
    let name = e.target.name;
    let value = e.target.value;
  
    if (name === 'category') {
      value = e.target.textContent || e.target.value;
  
      // Reset sleeves and collar if category is not Shirts or Tshirts
      if (value !== 'Shirts' && value !== 'Tshirts') {
        dispatch({ type: UPDATE_FILTERS, payload: { name: 'sleeves', value: 'all' } });
        dispatch({ type: UPDATE_FILTERS, payload: { name: 'collar', value: 'all' } });
      }
    }
  
    if (name === 'company') {
      value = e.target.textContent || e.target.value;
    }
    if (name === 'metalType') {
      value = value
    }
    if (name === 'collar') {
      value = e.target.textContent || e.target.value;
    }
  
    if (name === 'color') {
      value = e.target.dataset.color;
    }
  
    if (name === 'price') {
      value = Number(value);
    }
  
    if (name === 'shipping') {
      value = e.target.checked;
    }
    if (name === 'offers') {
      const id = e?.target?.dataset?.id ? e.target.dataset.id:e.target.value;
      value =id;
    }

    dispatch({ type: UPDATE_FILTERS, payload: { name, value } });
  };
  

  

  const clearFilters = () => {
    dispatch({ type: CLEAR_FILTERS });
  };

  useEffect(() => {
    dispatch({ type: LOAD_PRODUCTS, payload: products });
  }, [products]);

  useEffect(() => {
    dispatch({ type: FILTER_PRODUCTS });
    dispatch({ type: SORT_PRODUCTS });
  }, [products, state.sort, state.filters]);

  return (
    <FilterContext.Provider
      value={{
        ...state,
        setGridView,
        setListView,
        updateSort,
        updateFilters,
        clearFilters,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};
// make sure use
export const useFilterContext = () => {
  return useContext(FilterContext);
};
